"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDynamicSharedSlice = exports.isStaticSharedSlice = exports.SharedSlice = exports.SharedSliceType = exports.Variation = void 0;
const tslib_1 = require("tslib");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const withFallback_1 = require("io-ts-types/lib/withFallback");
const common_1 = require("../../../common");
const NestableWidget_1 = require("../nestable/NestableWidget");
const IMAGE_PLACEHOLDER_URL = "https://images.prismic.io/slice-machine/621a5ec4-0387-4bc5-9860-2dd46cbc07cd_default_ss.png?auto=compress,format";
exports.Variation = t.exact(t.intersection([
    t.type({
        id: t.string,
        name: t.string,
        description: t.string,
        imageUrl: (0, withFallback_1.withFallback)(t.string, IMAGE_PLACEHOLDER_URL),
        docURL: t.string,
        version: t.string,
    }),
    t.partial({
        display: t.string,
        primary: t.record(common_1.WidgetKey, NestableWidget_1.NestableWidget),
        items: t.record(common_1.WidgetKey, NestableWidget_1.NestableWidget),
    }),
]));
exports.SharedSliceType = "SharedSlice";
const LegacyPath = t.string;
const VariationId = t.string;
exports.SharedSlice = t.exact(t.intersection([
    t.type({
        id: t.string,
        type: t.literal(exports.SharedSliceType),
        name: t.string,
        variations: t.readonlyArray(exports.Variation),
    }),
    t.partial({
        description: t.string,
        legacyPaths: t.record(LegacyPath, VariationId),
    }),
]));
function isStaticSharedSlice(slice) {
    return slice.type === "SharedSlice";
}
exports.isStaticSharedSlice = isStaticSharedSlice;
function isDynamicSharedSlice(slice) {
    return slice.type === "SharedSlice";
}
exports.isDynamicSharedSlice = isDynamicSharedSlice;
